module.exports = __webpack_public_path__ + "static/media/visa.e4faeddd.svg";